import {Trans, useTranslation} from "react-i18next";
import {useStep} from "utils";
import {Bottom, LinkButton, RiveFetch, Top} from "parts";
import React from "react";

export function PrePaywall2({step, toAdd, nextUrl, preload}) {
  const
    {t} = useTranslation('common', {keyPrefix: 'prepaywall2'})

  useStep({step, toAdd})

  // const items = [
  //   {icon: 'training', name: 'Confidence', value: '+35%', rgb: '177, 114, 232'},
  //   {icon: 'book', name: 'Eloquence', value: '+22%', rgb: '243, 183, 55'},
  //   {icon: 'comment_full', name: 'Clarity', value: '+28%', rgb: '142, 190, 245'}
  // ]

  return (
    <>
      <style>{
`.notices p { position: relative; padding-left: 24px }
.notices p:before { content: ''; position: absolute; width: 4px; left: 0; top: 0; bottom: 0; background-color: #F6C558; border-radius: 2px }`
      }</style>
      <div className={'wrap fixed'}>
        <Top className={'pb-0'} style={{justifyContent: 'space-between'}}>
          <h1 style={{marginBottom: 40}}>{t('h1')}</h1>

          <div className={'surface w-100'} style={{padding: 20}}>
            <img width={80} height={84} alt="" style={{marginTop: -58}}
                 src={'/charisma/static/img/prepaywall/rocket.png'}/>

            <h2 className={'h4 mb-2'}>{t('header')}</h2>

            <div dir={'ltr'} className={'row gap-2 center'}>
              <img src={'/static/img/paywall/wreath-left.png'} alt={''} width={44} height={68}/>
              <div className={'text-center'}>
                <p className={'h2 fw-bold'} style={{color: '#F6C558'}}>
                  <img width={32} height={24} alt="" className={'me-2'} style={{marginBottom: -2}}
                       src={'/charisma/static/img/prepaywall/people.svg'}/>
                  756,930+
                </p>
                <p className={'notice-2 small-sm'}>{t('note')}</p>
              </div>
              <img src={'/static/img/paywall/wreath-right.png'} alt={''} width={44} height={68}/>
            </div>
          </div>

          <div className={'row mb-2'} style={{gap: 40}}>
            <RiveFetch width={106} height={220} style={{maxWidth: 106}} className={'w-100'}
                       image={'/charisma/static/img/prepaywall/phone.png'}
                       src={'charisma_quiz.riv'} module={true}
                       artboard={'illustration-3'} stateMachines={'state-machine'}
            />

            <div className={'small text-start stack notice-2 bold-light notices'} style={{gap: 24}}>
              <Trans i18nKey={'list'} t={t}>
                <p>Tailored <b>Study Plan</b> based on your goal</p>
                <p><b>200+</b> Expert-Led Exercises</p>
                <p>Smart Progress Tracking + <b>AI Feedback</b></p>
                <p><b>Community</b> Ratings & Insights</p>
              </Trans>
            </div>
          </div>

          <LinkButton to={nextUrl}>{t('btn')}</LinkButton>

          <p/>
        </Top>

        <Bottom footer={false} preload={preload}/>
      </div>
    </>
  )
}